import { useWorkflow } from "@/hooks/useWorkflow";


export const GreetingCard: React.FC = () => {
    const { greeting } = useWorkflow();

    return (
        <div className="mb-6">
            <div className="pt-6">
                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                    {greeting}
                </h1>
                <p className="text-gray-600">
                    Ready to create some impactful content? Choose an option below to get started.
                </p>
            </div>
        </div>
    );
};
